// extracted by mini-css-extract-plugin
module.exports = {"messageText":"_9370cdd7 _a2211d17","wrapper":"_fd097132","linkTextWrapper":"_e184844f _65bcb5bc _7bcd0657 _a2211d17","linkText":"_24551a1c _a2211d17"};